"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importDefault(require("react"));
const UiKitBase_1 = require("../UiKitBase");
const RowForStatus = (props) => {
    const tooltipText = 'The quick brown fox jumps over the lazy dog';
    return (react_1.default.createElement(UiKitBase_1.UiKitBase.TableRow, null,
        react_1.default.createElement(UiKitBase_1.UiKitBase.Text.BodyRegular, null, props.status),
        react_1.default.createElement(UiKitBase_1.UiKitBase.Tooltip, { tooltip: tooltipText, status: props.status, placement: 'top' }),
        react_1.default.createElement(UiKitBase_1.UiKitBase.Tooltip, { tooltip: tooltipText, status: props.status, placement: 'bottom' }),
        react_1.default.createElement(UiKitBase_1.UiKitBase.Tooltip, { tooltip: tooltipText, status: props.status, placement: 'left' }),
        react_1.default.createElement(UiKitBase_1.UiKitBase.Tooltip, { tooltip: tooltipText, status: props.status, placement: 'right' }),
        react_1.default.createElement(UiKitBase_1.UiKitBase.Text.BodyRegular, null, "\u00A0")));
};
const Tooltip = () => (react_1.default.createElement("table", { style: {
        width: '100%',
        textAlign: 'left',
        borderCollapse: 'collapse',
    } },
    react_1.default.createElement("colgroup", null,
        react_1.default.createElement("col", { span: 1, style: { width: '150px' } }),
        react_1.default.createElement("col", { span: 1, style: { width: '150px' } }),
        react_1.default.createElement("col", { span: 1, style: { width: '150px' } }),
        react_1.default.createElement("col", { span: 1, style: { width: '150px' } }),
        react_1.default.createElement("col", { span: 1, style: { width: '150px' } }),
        react_1.default.createElement("col", { span: 1, style: { width: 'auto' } })),
    react_1.default.createElement(UiKitBase_1.UiKitBase.TableHeader, { columns: ['Status', 'Top', 'Bottom', 'Left', 'Right', ''], backgroundColor: '#F7F9FA' }),
    react_1.default.createElement("tbody", null,
        react_1.default.createElement(RowForStatus, { status: 'tip' }),
        react_1.default.createElement(RowForStatus, { status: 'info' }),
        react_1.default.createElement(RowForStatus, { status: 'info outline' }),
        react_1.default.createElement(RowForStatus, { status: 'warning' }),
        react_1.default.createElement(RowForStatus, { status: 'warning outline' }),
        react_1.default.createElement(RowForStatus, { status: 'error' }),
        react_1.default.createElement(RowForStatus, { status: 'error outline' }),
        react_1.default.createElement(RowForStatus, { status: 'question' }),
        react_1.default.createElement(RowForStatus, { status: 'todo' }),
        react_1.default.createElement(RowForStatus, { status: 'in progress' }),
        react_1.default.createElement(RowForStatus, { status: 'success' }),
        react_1.default.createElement(RowForStatus, { status: 'success outline' }))));
exports.Tooltip = Tooltip;
